import {BroadcastChannel} from 'broadcast-channel';
import {Observable, Subject} from 'rxjs';
import {BroadcastEventSymbol} from '../common/symbols';
import {Constructor, EventContext} from '../common/types';

const channel = new BroadcastChannel('esgi_event_bus_channel');
type BusEvent = {event: number, args: any, context: EventContext};

class BroadcastEventBusImpl {
	private readonly bus$ = new Subject<BusEvent>();

	constructor() {
		channel.addEventListener('message', (event) => {
			if (event) {
				if (event.ESGI_INFO?.FrontendVersion !== (window as any).ESGIGlobalVariables?.FrontendVersion) {
					return;
				}
				const args = event.args ? JSON.parse(event.args) : null;
				this.bus$.next({event: event.eventID, args: args, context: {source: 'other', crossTab: true}});
			}
		});
	}

	public get eventsBus$(): Observable<BusEvent> {
		return this.bus$.asObservable();
	}

	public dispatch = <T>(event: Constructor<T>, args: T): void => {
		const broadcastMeta = event.prototype[BroadcastEventSymbol];
		if (broadcastMeta) {
			channel.postMessage({
				eventID: broadcastMeta.eventID,
				args: args ? JSON.stringify(args) : null,
				ESGI_INFO: (window as any).ESGIGlobalVariables,
			});
		}
	};
}

export const BroadcastEventBus = new BroadcastEventBusImpl();
